<template>
  <el-dialog :title="flow.title" :visible.sync="flow.visible" width="80%" @close="onCloseCaseFlow">
    <el-form>
      <el-collapse v-model="activeNames">
        <el-collapse-item :title="`案件: ${caseItem.defendant} - ${(caseItem.agreement && caseItem.agreement.HouseName) || ''}`" :name="index" v-for="(caseItem, index) in flow_case_list" :key="caseItem.id || index">
          <el-form :model="caseItem" :ref="`subForm_${index}`" :rules="subFormRules">

            <div v-if="type === 'mediation'">
              <el-form-item label="调解类型" label-width="120px" prop="mediation_type" required>
                <el-select v-model="caseItem.mediation_type" placeholder="请选择调解类型" @change="onMediationTypeChange(caseItem)">
                  <el-option :value="'pre'" label="诉前调解"></el-option>
                  <el-option :value="'during'" label="诉中调解"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="caseItem.mediation_type === 'pre'" label="调解方式" label-width="120px">
                <el-select v-model="caseItem.mediation_method" placeholder="请选择调解方式">
                  <el-option :value="'community'" label="社区调解"></el-option>
                  <el-option :value="'moot_hall'" label="矛厅调解"></el-option>
                  <el-option :value="'court_extra'" label="法院编外人员调解"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="调解时间" label-width="120px" prop="mediation_date" required>
                <el-date-picker v-model="caseItem.mediation_date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="跟进人" label-width="120px">
                <el-input v-model="caseItem.follow_user" placeholder="请输入跟进人"></el-input>
              </el-form-item>
              <el-form-item label="调解结果" label-width="120px" prop="mediation_result" required>
                <el-select v-model="caseItem.mediation_result" placeholder="请选择调解结果">
                  <el-option :value="'success'" label="调解成功"></el-option>
                  <el-option :value="'failed'" label="调解失败"></el-option>
                  <el-option :value="'pending'" label="调解中"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="调解情况说明" label-width="120px" prop="mediation_remark" required>
                <el-input v-model="caseItem.mediation_remark" type="textarea" placeholder="请输入备注"></el-input>
              </el-form-item>
              <el-form-item label="调解文件" label-width="120px">
                <div style="width: 100%">
                  <el-upload :http-request="(param) => handleUploadFile(param, caseItem, 'mediation_file')" action="" multiple
                             :data="{key:'mediation_file', data : caseItem}" :file-list="caseItem.mediation_file">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                </div>
              </el-form-item>
            </div>

            <div v-if="type === 'preservation'">
              <el-form-item label="保全时间" label-width="120px" prop="preservation_date" required>
                <el-date-picker v-model="caseItem.preservation_date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="保全金额" label-width="120px" prop="preservation_amount" required>
                <el-input v-model="caseItem.preservation_amount" type="number" placeholder="请输入保全金额"></el-input>
              </el-form-item>
              <el-form-item label="跟进人" label-width="120px">
                <el-input v-model="caseItem.follow_user" placeholder="请输入跟进人"></el-input>
              </el-form-item>
              <el-form-item label="备注" label-width="120px">
                <el-input v-model="caseItem.preservation_remark" type="textarea" placeholder="请输入备注"></el-input>
              </el-form-item>
              <el-form-item label="保全文件" label-width="120px">
                <div style="width: 100%">
                  <el-upload :http-request="(param) => handleUploadFile(param, caseItem, 'preservation_file')" action="" multiple
                             :data="{key:'preservation_file', data : caseItem}" :file-list="caseItem.preservation_file">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                </div>
              </el-form-item>
            </div>

            <div v-if="type === 'court'">
              <el-form-item label="开庭时间" label-width="120px" prop="court_date" required>
                <el-date-picker v-model="caseItem.court_date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="开庭地点" label-width="120px">
                <el-input v-model="caseItem.court_location" placeholder="请输入开庭地点"></el-input>
              </el-form-item>
              <el-form-item label="审判人员" label-width="120px">
                <el-input v-model="caseItem.court_judge" placeholder="请输入审判人员"></el-input>
              </el-form-item>
              <el-form-item label="跟进人" label-width="120px">
                <el-input v-model="caseItem.follow_user" placeholder="请输入跟进人"></el-input>
              </el-form-item>
<!--              <el-form-item label="庭审结果" label-width="120px" prop="court_result" required>-->
<!--                <el-select v-model="caseItem.court_result" placeholder="请选择庭审结果">-->
<!--                  <el-option :value="'adjourn'" label="休庭"></el-option>-->
<!--                  <el-option :value="'verdict'" label="判决"></el-option>-->
<!--                  <el-option :value="'mediation'" label="调解"></el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
              <el-form-item label="开庭阶段" label-width="120px" prop="trial_stage" required>
                <el-select v-model="caseItem.trial_stage" placeholder="请选择开庭阶段">
                  <el-option :value="1" label="仲裁"></el-option>
                  <el-option :value="2" label="人民法院-一审"></el-option>
                  <el-option :value="3" label="中级法院-二审"></el-option>
                  <el-option :value="4" label="高级法院-再审"></el-option>
                  <el-option :value="5" label="检察院"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注" label-width="120px">
                <el-input v-model="caseItem.court_remark" type="textarea" placeholder="请输入备注"></el-input>
              </el-form-item>
              <el-form-item label="开庭文件" label-width="120px">
                <div style="width: 100%">
                  <el-upload :http-request="(param) => handleUploadFile(param, caseItem, 'court_file')" action="" multiple
                             :data="{key:'court_file', data : caseItem}" :file-list="caseItem.court_file">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                </div>
              </el-form-item>
            </div>

            <div v-if="type === 'appeal'">
              <el-form-item label="上诉时间" label-width="120px" prop="appeal_date" required>
                <el-date-picker v-model="caseItem.appeal_date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="上诉理由" label-width="120px" prop="appeal_reason" required>
                <el-input v-model="caseItem.appeal_reason" type="textarea" placeholder="请输入上诉理由"></el-input>
              </el-form-item>
              <el-form-item label="跟进人" label-width="120px">
                <el-input v-model="caseItem.follow_user" placeholder="请输入跟进人"></el-input>
              </el-form-item>
              <el-form-item label="上诉文件" label-width="120px">
                <div style="width: 100%">
                  <el-upload :http-request="(param) => handleUploadFile(param, caseItem, 'appeal_file')" action="" multiple
                             :data="{key:'appeal_file', data : caseItem}" :file-list="caseItem.appeal_file">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </el-collapse-item>
      </el-collapse>

      <el-form-item label-width="120px">
        <el-button type="primary" @click="sendFlowData" :loading="loading">提交</el-button>
        <el-button @click="onCloseCaseFlow">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import caseJs from './case.js'
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "case_flow",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title : {
      type: String,
      default: ''
    },
    type : {
      type : String ,
      default : ''
    },
    case_list : {
      type : Array ,
      default : [],
    }
  },
  watch : {
    "visible":{
      handler: function (n,o) {
        this.flow.visible = n;
        if(n) {
          this.$nextTick(() => {
            this.resetData();
          });
        }
      },
      deep: true
    },
    "title" : {
      handler: function(n , o){
        this.flow.title = n;
      }
    },
    case_list: {
      handler: function(val) {
        if(this.visible && val && val.length > 0) {
          this.resetData();
        }
      },
      deep: true
    },
    project_type: {
      type: Number,
      default: ''
    },
  },
  data : function(){
    return {
      flow : {
        title : '',
        visible : false,
        form: {
          id: '',
          actions: [],
          flow_id: '',
          flow_name: '',
          flow_type: '',
        }
      },
      activeNames: [],
      subFormRules: {
        mediation_type: [
          { required: true, message: '请选择调解类型', trigger: 'change' }
        ],
        mediation_date: [
          { required: true, message: '请选择调解时间', trigger: 'change' }
        ],
        mediation_result: [
          { required: true, message: '请选择调解结果', trigger: 'change' }
        ],
        mediation_remark: [
          { required: true, message: '请输入调解情况说明', trigger: 'blur' }
        ],
        preservation_date: [
          { required: true, message: '请选择保全时间', trigger: 'change' }
        ],
        preservation_amount: [
          { required: true, message: '请输入保全金额', trigger: 'blur' }
        ],
        court_date: [
          { required: true, message: '请选择开庭时间', trigger: 'change' }
        ],
        court_result: [
          { required: true, message: '请选择庭审结果', trigger: 'change' }
        ],
        appeal_date: [
          { required: true, message: '请选择上诉时间', trigger: 'change' }
        ],
        appeal_reason: [
          { required: true, message: '请输入上诉理由', trigger: 'blur' }
        ]
      },
      loading : false,
      flow_case_list: []
    };
  },
  methods : {
    onCloseCaseFlow(){
      this.flow.visible = false;
      this.$emit('close' , false);
    },
    onMediationTypeChange(caseItem) {
      if (caseItem.mediation_type !== 'pre') {
        caseItem.mediation_method = '';
      }
    },
    resetData() {
      this.flow_case_list = [];
      this.case_list.forEach(item => {
        let cItem = {
          ...item,
          file_list: item.file_list || []
        };
        this.flow_case_list.push(cItem);
      });
    },
    sendFlowData(){
      let post_params = {
        flow_list : [],
        flow_type : this.type
      };
      let max_money = 0;
      this.flow_case_list.forEach((item , index) => {
        let flow_data = {}

        switch(this.type){
          case 'mediation':
            flow_data = {
              mediation_type: item.mediation_type,
              mediation_method: item.mediation_method,
              mediation_date: item.mediation_date,
              follow_user: item.follow_user,
              mediation_result: item.mediation_result,
              remark: item.mediation_remark
            };
            break;
          case 'preservation':
            flow_data = {
              preservation_date: item.preservation_date,
              preservation_amount: item.preservation_amount,
              follow_user: item.follow_user,
              remark: item.preservation_remark
            };
            if(parseFloat(item.preservation_amount ) > max_money){
              max_money = parseFloat(item.preservation_amount );
            }
            break;
          case 'court':
            flow_data = {
              court_date: item.court_date,
              court_location: item.court_location,
              court_judge: item.court_judge,
              follow_user: item.follow_user,
              court_result: item.court_result,
              remark: item.court_remark,
              trial_stage: item.trial_stage
            };
            break;
          case 'appeal':
            flow_data = {
              appeal_date: item.appeal_date,
              appeal_reason: item.appeal_reason,
              follow_user: item.follow_user
            };
            break;
        }

        post_params.flow_list.push({
          case_id : item.id,
          flow_data : flow_data ,
          file_list : item.file_list || []
        });
      });

      const validatePromises = this.flow_case_list.map((item, index) => {
        return new Promise((resolve) => {
          const formRef = this.$refs[`subForm_${index}`];
          if (formRef && typeof formRef.validate === 'function') {
            formRef.validate((valid) => {
              resolve(valid);
            });
          } else if (formRef && Array.isArray(formRef) && formRef[0] && typeof formRef[0].validate === 'function') {
            formRef[0].validate((valid) => {
              resolve(valid);
            });
          } else {
            resolve(true);
          }
        });
      });

      Promise.all(validatePromises).then((results) => {
        const allValid = results.every(r => r === true);
        if (!allValid) {
          this.$message.error('请填写完整所有必填项');
          return;
        }
        this.loading = true;
        ButlerHttp.post('LawCase/saveFlow' , post_params , (res) =>{
          if(res.code){
            let batch_no = res.data.batch_no;
            let url = '';

            if (['appeal'].includes(this.type)) {
              let amount = this.flow_case_list.reduce((sum, item) => sum + (item.legal_money || 0), 0);
              amount = parseFloat(amount).toFixed(2);
              const typeMap = {
                'appeal': '二审',
                'court': '开庭记录',
                'preservation': '诉讼保全'
              };
              const urlParams = {
                sheet_id: '349',
                master_id: '286',
                timeValue: caseJs.getTimestamp(),
                batch_no: batch_no,
                amount: amount,
                type: typeMap[this.type] || this.type
              };
              url = `https://crm.gdzawy.com:9000/#/flow/FlowView?${new URLSearchParams(urlParams).toString()}`;
            } else if(this.type == 'fill'){
              url = "https://crm.gdzawy.com:9000/#/flow/FlowView?sheet_id=311&master_id=251&timeValue=" + caseJs.getTimestamp() + "&batch_no=" + batch_no;
            }else if(this.type == 'preservation'){
              let project_type_label = this.project_type == 1 ? '在管' : '撤场'
              url = "https://crm.gdzawy.com:9000/#/flow/FlowView?sheet_id=361&master_id=297&timeValue=" + caseJs.getTimestamp() + "&batch_no=" + batch_no + "&amount=" + max_money + '&type=' + project_type_label;
            }else if(['court', 'mediation'].includes(this.type)){
              // 调解不发起流程
              this.$message.success('操作成功');
              this.onCloseCaseFlow();
              this.loading = false;
              return null ;
            }else{
              url = "https://crm.gdzawy.com:9000/#/flow/FlowView?sheet_id=312&master_id=252&timeValue=" + caseJs.getTimestamp() + "&batch_no=" + batch_no;
            }
            window.open(url);
            this.onCloseCaseFlow();
            this.$message.success('操作成功');
          }else{
            this.$message.error(res.msg);
          }
          this.loading = false;
        });
      });
    },
    handleUploadFile(params , caseItem , file_key) {
      let file_name = params.file.name;

      caseJs.uploadFile(params.file , (res) =>{
        if(res && res.hasOwnProperty('path')){
          if(!caseItem.hasOwnProperty('file_list')){
            caseItem.file_list = [];
          }
          caseItem.file_list.push({
            file_name : file_name ,
            file_key : file_key ,
            file_url : res.path
          });
        }
      })
    },
    getFlowData(){
      // 获取流程数据
    }
  },
}
</script>

<style scoped>
.el-collapse-item__header {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/law_case/case_flow.vue